import type { CurrentSubscription } from '@setplex/tria-api'

import { getMaxAllowedPixelsBySubscription } from '~/entities/subscriptions/utils'

interface IIsVideoQualityBlockedProps {
  minVideoQuality: number
  currentSubscription: CurrentSubscription | null
  isVideoQualityAvailabile: (props: {
    shouldShowUpgrade: boolean
    minAvailableQuality: number | null
    isRewinded?: boolean
  }) => void
  isRewinded?: boolean
}
export const isVideoQualityBlocked = ({
  minVideoQuality,
  currentSubscription,
  isVideoQualityAvailabile,
  isRewinded,
}: IIsVideoQualityBlockedProps) => {
  if (!currentSubscription?.maxQuality) {
    isVideoQualityAvailabile({
      shouldShowUpgrade: false,
      minAvailableQuality: null,
    })
    return false
  }

  const maxAllowedPixels = getMaxAllowedPixelsBySubscription(
    currentSubscription.maxQuality
  )

  const shouldShowUpgrade = minVideoQuality > maxAllowedPixels

  isVideoQualityAvailabile({
    shouldShowUpgrade: shouldShowUpgrade,
    minAvailableQuality: shouldShowUpgrade ? minVideoQuality : null,
    isRewinded,
  })
  return shouldShowUpgrade
}
